import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { withT } from "services/translation/";

import Loading from "components/Loading";

import { Row, Col } from "react-bootstrap";

import Icon from "components/Icons/Icon";

import DataTable from "./DataTable";

import {
  loadUserManagementUserListStart,
  loadUserManagementUserListCancel
} from "services/redux/actions/";
import { loadSingleSiteUsersStart } from "services/redux/actions/singleSites";

import { getPathRootFromRoute } from "services/redux/selectors/app/";
import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";

/**
 * User Management UserList
 *
 * Loads and displays a list of users that have access
 * to an enterprise or a group for management
 *
 */
class UserList extends React.Component {
  loadUserList = props => {
    const {
      pathRoot,
      origin,
      users,
      group,
      enterprise,
      companyId,
      sudoSiteId,
    } = this.props;

    // Already loading
    if (users.loading === true) {
      return;
    }
    
    // if (users.loading === null) {
      if (origin === "Companies") {
        this.props.dispatch(
          loadSingleSiteUsersStart({
            originType: "company",
            originId: companyId,
            sudo_site_id: sudoSiteId,
          })
        );
      } else if (origin === "SiteView") {
        const params = {
          sudo_site_id: sudoSiteId,
        }
        if (pathRoot === "enterprise") {
          params["originType"] = "enterprise";
          params["originId"] = enterprise.id;
        }
        this.props.dispatch(
          loadSingleSiteUsersStart(params)
        );
      } else {
        this.props.dispatch(
          loadUserManagementUserListStart({
            enterprise_id: enterprise.id,
            group_id: group.id
          })
        );
      }
    // }
  };

  componentDidMount() {
    const { origin, originType, originId } = this.props;
    if (origin === "SiteView") {
      if (originType !== "" && !!originId) {
        this.loadUserList(this.props);
      }
    } else {
      this.loadUserList(this.props);
    }
  }
  
  // UNSAFE_componentWillReceiveProps = nextProps => {
  //   if (this.props !== nextProps) {
  //     this.loadUserList(nextProps);
  //   }
  // };
  componentDidUpdate(prevProps) {
    const { origin, group, enterprise, companyId, sudoSiteId } = this.props;

    if (origin === "Companies") {
      const newCompany = prevProps.companyId !== companyId;
      const newSudoSiteId = prevProps.sudoSiteId !== sudoSiteId;

      // Only load on new company or sudo site
      if (newCompany || newSudoSiteId) {
        this.loadUserList(this.props);
      }
    } else if (origin === "SiteView") {
      const newSudoSiteId = prevProps.sudoSiteId !== sudoSiteId;

      // Only load on new sudo site
      if (newSudoSiteId) {
        this.loadUserList(this.props);
      }
    } else {
      const newGroup = prevProps.group.id !== group.id;
      const newEnterprise = prevProps.enterprise.id !== enterprise.id;

      // Only load on new group
      if (newGroup || newEnterprise) {
        this.loadUserList(this.props);
      }
    }
  }

  componentWillUnmount = () => {
    this.props.dispatch(loadUserManagementUserListCancel());
  };

  render() {
    const { origin, users, roleId, t, siteName, companyId, sudoSiteId, originType, originId } = this.props;

    const loading = users.loading === true;

    return (
      <>
        <Row id="UserList">
          <Col>
            <h4 className="mt-0 pb-2 header-title">
              <Icon className="fas fa-users pr-1" />
              {t("title")}
              {loading && <Loading />}
            </h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <DataTable
              roleId={roleId}
              origin={origin}
              siteName={siteName}
              companyId={companyId}
              sudoSiteId ={sudoSiteId}
              originType={originType}
              originId={originId}
            />
          </Col>
        </Row>
      </>
    );
  }
}
UserList.propTypes = {
//   group: PropTypes.object.isRequired,
//   enterprise: PropTypes.object.isRequired,
//   roleId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired
};
const mapStateToProps = (state, props) => {
  return {
    pathRoot: getPathRootFromRoute(state),
    enterprise: getEnterpriseFromRoute(state, props),
    users: state.users,
  };
};
export default withT(
  connect(mapStateToProps)(UserList),
  "user_management.user_list"
);
